// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2Olrn","requiredAsterisk":"Info_requiredAsterisk__2Evam"};